import { ILinkAutorizacionResponse } from '../types/responses'
import { axiosInstanceIntegraciones } from '../../../utils/axiosGlobalUtils'
import { AxiosResponse } from 'axios'
import { GetCodigoTienda, TiendaNames } from '../types'

export const GetLinkAutorizacion = async (tenant: string, tienda: TiendaNames, codLocal: string, url: string) =>
  (await axiosInstanceIntegraciones.get(
    `/${tenant}/autorizacion/link?codLocal=${codLocal}&url=${url}&codigoTienda=${GetCodigoTienda(tienda)}`
  )) as AxiosResponse<ILinkAutorizacionResponse>
